// TShirtHeroRegister.tsx
import * as React from 'react';
import { connect } from 'react-redux';
import { CSSProperties } from 'react';
import { browserHistory } from 'react-router';
import Radium, { StyleRoot } from 'radium';
import * as Tgcc from '../../tgccGlobal';
import * as Request from '../../tgccRequest';
import Tooltip from '../Tooltip';
import ThankYouPopup from './ThankYouPopup';
import { TShirtHeroLoginPopup } from './TShirtHeroLoginPopup';

const spotLightImage1 = Tgcc.ResolveUrl('~/images/superhero-spotlights-1-resized.png');
const spotLightImage2 = Tgcc.ResolveUrl('~/images/superhero-spotlights-2-resized.png');


// Define the CSS properties for various elements
const formStyle: React.CSSProperties = {
    display: 'flex',
    marginTop: '4vh',
    flexDirection: 'column',
    width: '35vw',
    zIndex: 1100,
    backgroundColor: '#333333',
    padding: '20px',
    borderRadius: '5px',
    '@media (max-width: 768px)': {
        width: '90vw',
    },
};

const modalBackdropStyle: CSSProperties = {
    position: 'fixed', // or 'absolute' if 'fixed' is not suitable for your layout
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Adjust the opacity as needed
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1200, // Ensure it's above other content
  };

  const modalContentStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column', // Adjust to column layout
    alignItems: 'center',    // Center items horizontally
    position: 'relative',    // Relative positioning for absolutely positioned children
    marginTop: '20px',
    marginBottom: '20px',
    width: '100vw',  
};
  

// Container Style, which will position the form and images relative to this container
const formContainerStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column', // Adjust to column layout
    alignItems: 'center',    // Center items horizontally
    position: 'relative',    // Relative positioning for absolutely positioned children
    marginTop: '20px',
    marginBottom: '20px',
    width: '100vw',
  };
  
  // Style for the first spotlight image
  const spotLightImage1Style: React.CSSProperties = {
    position: 'absolute',
    opacity: 0.7,
    top: '0', // Align to the top of the container
    left: '5vw', // Align to the left of the container
    width: '35vw', // Adjust the size as needed
    height: 'auto', // Adjust the size as needed
    backgroundImage: `url(${spotLightImage1})`,
    zIndex: 1100,
    backgroundSize: 'cover', // This will ensure the image covers the area without distorting aspect ratio
    '@media (max-width: 768px)': {
        display: 'none'
    },
};

  
  // Style for the second spotlight image
  const spotLightImage2Style: React.CSSProperties = {
    position: 'absolute',
    zIndex: 1100,
    opacity: 0.7,
    bottom: '0', // Align to the bottom of the container
    right: '5vw', // Align to the right of the container
    width: '35vw', // Adjust the size as needed
    height: 'auto', // Adjust the size as needed
    backgroundImage: `url(${spotLightImage2})`,
    backgroundSize: 'cover', // This will ensure the image covers the area without distorting aspect ratio
    '@media (max-width: 768px)': {
        display: 'none'
    },
};

  

const baseInputStyle: CSSProperties = {
    padding: '10px 15px',
    borderRadius: '4px',
    fontFamily: "trajan-color",
    marginBottom: '10px',
    backgroundColor: 'transparent', // Transparent background
    border: '2px solid black', // Thicker, black border
    boxShadow: '5px 5px 0px rgba(0,0,0,0.75)', // Shadow for 3D effect
    color: 'white', // White text
    boxSizing: 'border-box', // Include padding in width calculation
    fontSize: '16px',
  };
  
  const inputStyle: CSSProperties = {
    ...baseInputStyle,
    backgroundColor: '#fff',
    color: '#333',
    '::placeholder': {
        color: '#ccc', // Lighter color for placeholder text
      },
    ':focus': {
      borderColor: '#5b9dd9',
      outline: 'none',
      boxShadow: '0 0 5px rgba(91, 157, 217, 0.5)', // Add a soft blue glow
    },
    '@media (max-width: 768px)': {
        padding: '8px',
    },
  };
  
  const selectStyle: CSSProperties = {
    ...baseInputStyle,
        marginBottom: '10px',
        padding: '10px',
        borderRadius: '5px',
        border: '1px solid #ccc',
        backgroundColor: '#fff', // This ensures the dropdown background is white
        color: '#333', // Default text color for the select box
        // Add styles for the dropdown options
        WebkitAppearance: 'none', // For Safari
        MozAppearance: 'none', // For Firefox
        appearance: 'none', // Standard
        backgroundImage: `url('data:image/svg+xml;utf8,<svg fill="${encodeURIComponent(
          '#333' // Arrow color
        )}" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>')`, // This is an encoded SVG arrow
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 10px top 40%',
        backgroundSize: '35px', // Size of the arrow image
        ':focus': {
          borderColor: '#5b9dd9',
          outline: 'none',
        },
        // You may need to ensure the options are styled when they're in the dropdown
        '& option': {
          color: '#333', // Text color for options
          backgroundColor: '#fff', // Background for options, ensuring they are visible
        },
    };
      
  
    const buttonStyle: CSSProperties = {
        ...baseInputStyle, // Continue using the base input styles for consistency
        padding: '10px 20px',
        backgroundColor: '#6893CC', // Maintain the bright color for visibility
        color: '#fff',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        fontFamily: "trajan-color",
        cursor: 'pointer',
        border: '2px solid black',
        boxShadow: 'none',
        marginTop: '10px', // Add some margin to the top for spacing
        ':hover': {
          backgroundColor: '#0056b3', // A slightly darker shade on hover
        },
        ':focus': {
          boxShadow: '0 0 0 2px rgba(0, 123, 255, 0.5)',
        },
        '@media (max-width: 768px)': {
            padding: '12px 15px',
        },
    };
    
    const loginLinkStyle: CSSProperties = {
        color: '#6893CC', // Use the primary color theme for the link for consistency
        fontWeight: 'bold', // Make it bold to stand out a bit as a clickable link
        textDecoration: 'underline', // Underline to signify that it is a link
        cursor: 'pointer', // Change cursor to pointer on hover to indicate a clickable link
        padding: '5px', // Add padding to make the clickable area larger
        backgroundColor: 'transparent', // Ensure the background is transparent
        border: 'none', // No border for a text link
        boxShadow: 'none', // No shadow for a text link
        marginTop: '8px', // Add some margin above for spacing
        display: 'inline-block', // Make the link inline with text
    };
    
  
const registrationHeaderStyle: React.CSSProperties = {
    fontFamily: "Bangers",
    letterSpacing: "1px",
    color: '#6893CC', // Bright color
    textShadow: '3px 3px 0px rgba(0,0,0,0.75)', // Shadow for depth
    textAlign: 'center',
};

const labelStyle: React.CSSProperties = {
    marginBottom: '5px',
    fontFamily: "trajan-color",
    color: '#fff',
    fontWeight: 'bold'
};

const buyerContainerStyle: React.CSSProperties = {
    marginBottom: '5px',
    color: '#fff',
    fontWeight: 'bold',
    display: 'flex',         // Use flex layout
    alignItems: 'center',    // Center items vertically
    justifyContent: 'flex-start', // Align items to the start of the container
};

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px'
};

const subheaderStyle: React.CSSProperties = {
    color: '#fff', 
    textAlign: 'center',
    fontFamily: "trajan-color",
    textTransform: 'uppercase',
    fontSize: '20px', 
    marginBottom: '20px',
};

const errorStyle: CSSProperties = {
    color: 'red', // Error message in red
    marginBottom: '10px', // Spacing before the submit button
    textAlign: 'center', // Center-align the error message
};


// Class definition //
class _TShirtHeroRegister extends React.Component<Tgcc.BaseProps, any> {
    _isMounted: boolean = false;
    state = {
        step: 1,
        error: '',
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        confirmPassword: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        phone: '',
        isBuyer: false,
        receiveTexts: false, 
        schoolName: '',      
        schools: [],
        studentGroup: '',    
        groupSize: '',
        showLoginPopup: false, // This controls the visibility of the login popup
        userMessage: 'Collegiate',
        isTShirtHeroRegistration: true, // Set to true for T-Shirt Hero registration
        attemptedEmail: '',
        isWaiting: false,
        showThankYouPopup: false,
        popupSource: '',

    };


    componentDidMount() {
    this._isMounted = true;
    Request.getSchools((schools) => {
        if (this._isMounted) {
        this.schoolsLoaded(schools);
        }
    });
    }

    componentWillUnmount() {
    this._isMounted = false;
    }

    schoolsLoaded(schools : string[]) {
        this.setState({schools: schools});
    }

    clearState = () => {
        this.setState({Schools: null,school:null,isCollegiate:false,Orgs:null,org:null});       
    }

    // Method to toggle the login popup visibility
    toggleLoginPopup = () => {
        this.setState({ showLoginPopup: !this.state.showLoginPopup });
    };



    handleGroupSizeChange = (event: React.FormEvent<HTMLSelectElement>) => {
        this.setState({ groupSize: event.currentTarget.value });
    };

    handleSchoolChange = (event: React.FormEvent<HTMLSelectElement>) => {
        this.setState({ school: event.currentTarget.value });
    };

    getSchools = () => {
        return this.state.schools.map((school, index) => (
            <option key={index} value={school}>{school}</option>
        ));
    }

    handleInputChange = (event: React.FormEvent<HTMLInputElement>) => {
        const target = event.currentTarget; // Use currentTarget for the specific element
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        let formattedValue = value;

    
        // Check if the input is the phone number field
        if (name === 'phone') {
            formattedValue = this.formatPhoneNumber(value);
        }


        this.setState({
            [name]: value,
            [name]: formattedValue,
            error: '', // Clear error message when the user starts typing
        });

        // If the input field is email, update the attemptedEmail as well
        if (name === 'email') {
            this.setState({ attemptedEmail: value });
        }

    };

    formatPhoneNumber = (value) => {
        // Remove all non-digits
        const numbers = value.replace(/[^\d]/g, '');
    
        // Capture groups of numbers
        const phoneNumber = numbers.substring(0, 10); // max length of US phone number
        const areaCode = phoneNumber.substring(0,3);
        const middle = phoneNumber.substring(3,6);
        const last = phoneNumber.substring(6,10);
    
        // Format pieces based on their existence
        let formattedNumber = '';
        if (phoneNumber.length > 6) {
            formattedNumber = `(${areaCode}) ${middle}-${last}`;
        } else if (phoneNumber.length > 3) {
            formattedNumber = `(${areaCode}) ${middle}`;
        } else if (phoneNumber.length > 0) {
            formattedNumber = `(${areaCode}`;
        }
    
        return formattedNumber;
    };

    

    handleCheckboxChange = (event: React.FormEvent<HTMLInputElement>) => {
        const target = event.currentTarget;
        const name = target.name;
        const checked = target.checked;
    
        this.setState({
            [name]: checked
        });
    };
    
    handleSelectChange = (event: React.FormEvent<HTMLSelectElement>) => {
        const target = event.currentTarget;
        const name = target.name;
        const value = target.value;
    
        this.setState({
            [name]: value,
        });
    };

    handleInitialRegistration = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        // Initial validations
        const { email, password, confirmPassword } = this.state;
        if (!email || !password || !confirmPassword) {
            this.setState({ error: 'Please fill in all fields.' });
            return;
        }

        if (password !== confirmPassword) {
            this.setState({ error: 'Passwords do not match.' });
            return;
        }

        // Check if the password meets the criteria
        const passwordValidationRegex = /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z]).{8,}$/;
        if (!passwordValidationRegex.test(password)) {
            this.setState({ error: 'Password must be at least 8 characters long and include an uppercase and lowercase letter, number, and a special character.' });
            return;
        }

        // If all validations pass, check email availability
        this.checkEmailAndProceed();
    };

      checkEmailAndProceed = () => {
        Request.checkEmailAvailability(this.state.email,
            (isInUse) => {
                if (isInUse) {
                    this.setState({ error: 'Email is already in use.'});
                } else {
                    // Email is available, proceed to next step
                    this.setState({ step: 2, error: '' });
                }
            },
            (error) => {
                // Handle error (show message or log)
                console.error('Error checking email:', error);
                this.setState({ error: 'An error occurred while checking the email.' });
            }
        );
    };

    validatePassword = () => {
        const { password } = this.state;
        const hasUpperCase = /[A-Z]/.test(password);
        const hasSpecialChar = /[!@#$%^&*()]/.test(password); // Regex for special characters
        const isLongEnough = password.length > 8;
        if (!isLongEnough || !hasUpperCase || !hasSpecialChar) {
            return false; // Validation failed
        }
        return true; // Validation passed
    };

    handleFollowUpRegistration = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        this.setState({ isWaiting: true });
    
        const { email, password, confirmPassword, firstName, lastName, address, address2, city, state, zip, phone, schoolName, studentGroup, isBuyer, receiveTexts, userMessage, groupSize } = this.state;

        var user = new Tgcc.UserInfo();
        user.email = email;
        user.firstName = firstName;
        user.lastName = lastName;
        user.schoolOrBusiness = schoolName;
        user.studentGroup = studentGroup;
        user.address = address;
        user.address2 = address2;
        user.city = city;
        user.state = state;
        user.zip = zip;
        user.phone = phone;
        user.smsAllowed = receiveTexts;
        user.buyer = isBuyer ? "Yes" : "No";
        user.type = userMessage;
        user.group = groupSize;

        user.isTShirtHeroRegistration = this.state.isTShirtHeroRegistration;
    
        Request.registerUser(user, password, confirmPassword,
            this.successfulRegistration,
            this.failedRegistration
        );
    };
    
    successfulRegistration = (userData: Tgcc.UserInfo) => {
        this.setState({ isWaiting: true });
        this.props.dispatch({type: Tgcc.StateAction.SetUserInfo, payload: userData});
        
        Request.loginUser(this.state.email, 
            this.state.password, 
            (ld: Tgcc.LoginData)=>{ Tgcc.successfulLogin(this.props.dispatch, ld)
            // After successful login, create the ghost proof
            
         Request.updateHeroLoginTimestamp(ld, this.state.email, 
            (response) => {
                
                console.log("Timestamp updated successfully:", response);
                
            },
            (error) => {
                console.error("Error updating timestamp:", error);
            }
            // Update the Hero Login Timestamp after successful login
         )
         
         Request.createGhostProof(userData, ld,
            (proof) => {
                console.log("Ghost proof created successfully", proof);
                // Proceed with showing the thank you popup or any other follow-up action
                this.setState({ showThankYouPopup: true });
            },
            (error) => {
                console.error("Failed to create ghost proof", error);
                // Decide how to handle errors in ghost proof creation
                // For example, you might still want to proceed with the registration flow
                this.setState({ showThankYouPopup: true });
            }
        );

        },
            this.failedLogin);

            this.setState({ isWaiting: false, showThankYouPopup: true }); // Update the state here
    }


    
    showThankYouPopup = (show: boolean, source: string) => {
        this.setState({ showThankYouPopup: show, popupSource: source });
    };

    handleViewDesigns = () => {
        this.setState({ showThankYouPopup: false }); // Hide the popup
        browserHistory.push(Tgcc.Routes.CampusDesignListView); // Redirect to the design list view
    };

    
    failedRegistration = (err: string) => {
        this.setState({ error: err, isWaiting: false });
    }
    
    failedLogin = (err: string) => {
        // Handle login failure after registration
        this.setState({error: "registration succeeded, but login failed", isWaiting: false});

    }
    
    

    renderInitialForm() {
        return (
            <form style={formStyle} onSubmit={this.handleInitialRegistration}>
            <h2 style={registrationHeaderStyle}>Join the Fight</h2>
            {/* <p style={subheaderStyle}>Discover how to win $1000 in group apparel</p> Subheader text */}
            {this.state.error && (
                <div style={{ color: 'red' }}>
                {this.state.error}
                <span onClick={this.toggleLoginPopup} style={loginLinkStyle}>Log In</span>
                </div>
            )}            
            <input key="email" type="email" name="email" placeholder="Email" style={inputStyle} onChange={this.handleInputChange} autoComplete="email" />
            <input key="password" type="password" name="password" placeholder="Password" style={inputStyle} onChange={this.handleInputChange} autoComplete="new-password" />
            <input key="confirmPassword" type="password" name="confirmPassword" placeholder="Confirm Password" style={inputStyle} onChange={this.handleInputChange} autoComplete="new-password" />
            <button type="submit" style={buttonStyle}>Submit</button>
        </form>
        );
    }
    

    renderFollowUpForm() {
        const infoIcon = (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" stroke="black" strokeWidth="2"/>
                <line x1="12" y1="8" x2="12" y2="12" stroke="black" strokeWidth="2"/>
                <circle cx="12" cy="16" r="1" fill="black"/>
            </svg>
        );

        return (
            <div id="formContainer" style={formContainerStyle}>
                <img src={spotLightImage1} alt="Spotlight 1" style={spotLightImage1Style} />
                <img src={spotLightImage2} alt="Spotlight 2" style={spotLightImage2Style} />


                <form style={formStyle} onSubmit={this.handleFollowUpRegistration}>
                <h2 style={registrationHeaderStyle}>Complete Your Profile:</h2>
                <p style={subheaderStyle}>Please provide additional details to complete your profile.</p> {/* Subheader text */}
                
                <div style={rowStyle}>
                    <label key="firstNameLabel" style={labelStyle} htmlFor="firstName">First Name:</label>
                    <input 
                        key="firstName" 
                        type="text" 
                        name="firstName"
                        id="firstName"
                        placeholder="Johnny" 
                        style={inputStyle} 
                        onChange={this.handleInputChange} 
                        value={this.state.firstName}
                        autoComplete="given-name"
                        required />
                </div>

                <div style={rowStyle}>
                    <label key="lastNameLabel" style={labelStyle} htmlFor="lastName">Last Name:</label>
                    <input 
                        key="lastName" 
                        type="text" 
                        name="lastName" 
                        id="lastName" 
                        placeholder="Appleseed" 
                        style={inputStyle} 
                        onChange={this.handleInputChange} 
                        value={this.state.lastName}
                        autoComplete="family-name" 
                        required
                    />
                </div>

                <div style={rowStyle}>
                    <label style={labelStyle}>School Name:</label>
                    <select key="schoolName" name="schoolName" style={selectStyle} onChange={this.handleSelectChange} value={this.state.schoolName} required>
                        {this.getSchools()}
                    </select>
                </div>
                <div style={rowStyle}>
                        <label style={labelStyle}>Student Group:</label>
                        <input key="studentGroup" type="text" name="studentGroup" placeholder="Ex: Wiffleball Club, Kappa Delta" style={inputStyle} onChange={this.handleInputChange} value={this.state.studentGroup} required/>
                    </div>

                    <div style={rowStyle}>
                        <label style={labelStyle}>Group Size:</label>
                        <select key="groupSize" name="groupSize" style={selectStyle} onChange={this.handleSelectChange} value={this.state.groupSize} required>
                            <option value="">Select Size</option>
                            <option value="1-23">1-23</option>
                            <option value="24-49">24-49</option>
                            <option value="50-99">50-99</option>
                            <option value="100-149">100-149</option>
                            <option value="150-299">150-299</option>
                            <option value="300+">300+</option>
                        </select>
                    </div>

                    <label key="addressLabel" style={labelStyle} htmlFor="address">Your Mailing Address:</label>
                    <input key="address" id="address" type="text" name="address" placeholder="123 Example St" style={inputStyle} onChange={this.handleInputChange} value={this.state.address} autoComplete='shipping street-address' required />

                    <input key="address2" id="address2" type="text" name="address2" placeholder="Apt 201" style={inputStyle} onChange={this.handleInputChange} value={this.state.address2} />

                    <label key="cityLabel" style={labelStyle} htmlFor="city">City:</label>
                    <input key="city" type="text" id="city" name="city" placeholder="Anytown" style={inputStyle} onChange={this.handleInputChange} value={this.state.city} autoComplete='address-level2' required />

                    <label key="stateLabel" style={labelStyle} htmlFor="state">State:</label>
                    <input key="state" type="text" id="state" name="state" placeholder="CA" style={inputStyle} onChange={this.handleInputChange} value={this.state.state} autoComplete='address-level1' required />

                    <label key="zipLabel" style={labelStyle} htmlFor="zip">Zip Code:</label>
                    <input key="zip" type="text" id="state" name="zip" placeholder="90210" style={inputStyle} onChange={this.handleInputChange} value={this.state.zip} autoComplete='postal-code' required/>

                    <label key="phoneLabel" style={labelStyle} htmlFor="phone">Phone Number:</label>
                    <input key="phone" type="text" id="phone" name="phone" placeholder="(555) 123-4567" style={inputStyle} onChange={this.handleInputChange} value={this.state.phone} autoComplete='tel-national' required />
                            <div>
                        <label>
                            <input key="recieveTexts" type="checkbox" name="receiveTexts" onChange={this.handleCheckboxChange} checked={this.state.receiveTexts} />
                            Receive text notifications?
                        </label>
                    </div>

                <div id="buyerContainer" style={buyerContainerStyle}>
                    <label>
                        <input key="isBuyer" type="checkbox" name="isBuyer" onChange={this.handleCheckboxChange} checked={this.state.isBuyer} />
                        Are you the buyer?
                    </label>

                    <Tooltip content={
                        <div>
                            <p style={{ paddingLeft: '10px' }}>Check this box if one of the following applies to you:</p>
                            <ul>
                                <li>T-Shirt Chair</li>
                                <li>Department Purchaser</li>
                                <li>Your Group/Organization's Apparel Buyer</li>
                                <li>Buyer for any official organization</li>
                            </ul>
                        </div>
                    }>
                        {infoIcon}
                    </Tooltip>
                </div>
                {this.state.error && <div style={errorStyle}>{this.state.error}</div>}

                {this.state.isWaiting ? <Tgcc.LoadingElement /> : <button type="submit" style={buttonStyle}>Submit</button>
}
            </form>
        </div>
        );
}
render() {

    const thankYouMessage = this.state.popupSource === 'login'
        ? "Thank you for confirming your address! HQ will be in touch with you soon!"
        : "You have officially joined the fight. HQ will be in touch with you soon!";

    return (
        <Radium.StyleRoot>
            <div>
                    {this.state.step === 1 ? this.renderInitialForm() : this.renderFollowUpForm()}
                    {this.state.showLoginPopup && (
                        <div style={modalBackdropStyle}>
                            <div style={modalContentStyle}>

                                <TShirtHeroLoginPopup
                                    isOpen={this.state.showLoginPopup}
                                    onClose={this.toggleLoginPopup}
                                    onLoginSuccess={() => { /* Handle successful login */ }}
                                    showThankYouPopup={this.showThankYouPopup}
                                    />

                            </div>
                        </div>
                    )}

                    <ThankYouPopup
                        isOpen={this.state.showThankYouPopup}
                        message={thankYouMessage}
                        buttonText="View Designs"
                        onClose={this.handleViewDesigns}
                    />
            </div>
        </Radium.StyleRoot>
    );
}

}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return {
        // your state mapping
    };
};

export var TShirtHeroRegister =  connect(mapStateToProps)(Radium(_TShirtHeroRegister));
